

import { ResponseType } from "../../Types/ServicesType/servicesType";
import { SearchParamsType } from "../CinicManagement/types";
import { UserListType } from "./types";
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
const {clinicId} = getConstants()

const {SettingsApi} = api
export const getAllBackUp = async (params:SearchParamsType):Promise<ResponseType<{backup:UserListType[],totalCount:number}>>=>{
    const result = await instance.post(`${SettingsApi.getAllBackUp}`,{...params,clinicId});
    return result.data;
}
export const sqlBackUp = async (params:{clinicId:number,doneBy:string}):Promise<ResponseType<any>>=>{
    const result = await instance.post(`${SettingsApi.sqlBackUp}`,params);
    return result.data;
}





